// extracted by mini-css-extract-plugin
export default {"wrapper":"GroupWorkPlaceModalForm_wrapper__nBLPg","loaderWrapper":"GroupWorkPlaceModalForm_loaderWrapper__EU2WU"};